import React, { useState } from "react";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";

function CostSavingByOrdersProDash() {
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");
  const [params, setParams] = useState({
    period: "monthly",
  });

  const { data, loading } = UseGetDashBoardWithParams("/dashboard/cost-save-by-order", params);

  const dataDummy =
    data?.top_orders_by_value?.map((product) => ({
      quotes: product.order,
      value: product.value,
      ordered: product.ordered_price,
      diffrence: product.difference,
    })) || [];

  const periods = [
    { value: "monthly", option: "Monthly" },
    { value: "quarterly", option: "Quarterly" },
    { value: "halfyearly", option: "Half Yearly" },
    { value: "yearly", option: "Yearly" },
  ];

  const hanChange = (e) => {
    setParams({
      period: e.target.value,
    });
    setSelectedPeriod(e.target.value);
  };

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Cost Savings by Orders</h3>
        </div>

        <select
          value={selectedPeriod}
          onChange={hanChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {periods.map((period) => (
            <option key={period.value} value={period.value}>
              {period.option}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Quote / Order</th>
                <th className="py-2 px-2 text-left">Quote Value</th>
                <th className="py-2 px-2 text-left">Ordered Price</th>
                <th className="py-2 px-2 text-right">Savings Diff</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {dataDummy && dataDummy.length > 0 ? (
                dataDummy.map((value, index) => {
                  const [valueCurrency, valueNumeric] = (value.value || "N/A").split(" ");
                  const [orderedCurrency, orderedNumeric] = (value.ordered || "N/A").split(" ");
                  const [differenceCurrency, differenceNumeric] = (value.diffrence || "N/A").split(" ");

                  const formattedValue = valueNumeric
                    ? Number(valueNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";
                  const formattedOrdered = orderedNumeric
                    ? Number(orderedNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";
                  const formattedDifference = differenceNumeric
                    ? Number(differenceNumeric).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : "N/A";

                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-semibold text-gray-800">{value.quotes || "N/A"}</td>
                      <td className="py-2.5 px-2 text-gray-600 font-medium">{`${valueCurrency || ""} ${formattedValue}`}</td>
                      <td className="py-2.5 px-2 text-blue-600 font-semibold">{`${orderedCurrency || ""} ${formattedOrdered}`}</td>
                      <td className="py-2.5 px-2 text-right">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
                          {`${differenceCurrency || ""} ${formattedDifference}`}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No savings data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CostSavingByOrdersProDash;